import axios from 'axios'
import store from '@/store'

const baseURL = process.env.VUE_APP_BEAPI;
const END_POINT_OTP_STATUS = '/v4/otp/status';
const END_POINT_OTP_METHODS = '/v4/contact';
const END_POINT_OTP_VALIDATE = '/v4/otp/validate';
const END_POINT_OTP_SEND = '/v4/otp/send';

axios.defaults.withCredentials = true
let client = axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
       withCredentials: true,
       crossDomain: true
   }
})

client.interceptors.request.use(async function (config) {
  let token = store.state.accessToken;
  config.headers.Authorization =  token ? `Bearer ${token}` : '';
  return config;
});

const getOTPStatus = () =>
  client.get(END_POINT_OTP_STATUS);

const getOTPMethods = () =>
  client.get(END_POINT_OTP_METHODS);

const sendOTP = (method) =>
  client.post(END_POINT_OTP_SEND, {ChannelType: method});

const verifyOTP = (refCode, token) =>
  client.post(END_POINT_OTP_VALIDATE, {
      Token: token,
      RefCode: refCode
  });

export {
  getOTPStatus,
  getOTPMethods,
  sendOTP,
  verifyOTP
}